// import { requireNativeModule } from "expo";

// declare class AyasofyazilimCameraModule {
//   recognizeTextFromUri(val: string): Promise<void>;
// }

// // This call loads the native module object from the JSI.
// export default requireNativeModule<AyasofyazilimCameraModule>(
//   "AyasofyazilimCamera"
// );
